import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("roj-cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("roj-cart", JSON.stringify(items));
  }, [items]);

  const value = useMemo(() => {
    const count = items.reduce((a, i) => a + i.qty, 0);
    return {
      items,
      count,
      open,
      setOpen,
      add: (product) =>
        setItems((prev) => {
          const ex = prev.find((i) => i.id === product.id);
          if (ex) return prev.map((i) => (i.id === product.id ? { ...i, qty: i.qty + 1 } : i));
          return [...prev, { ...product, qty: 1 }];
        }),
      inc: (id) => setItems((p) => p.map((i) => (i.id === id ? { ...i, qty: i.qty + 1 } : i))),
      dec: (id) =>
        setItems((p) => p.map((i) => (i.id === id ? { ...i, qty: i.qty - 1 } : i)).filter((i) => i.qty > 0)),
      remove: (id) => setItems((p) => p.filter((i) => i.id !== id)),
      clear: () => setItems([]),
      subtotal: (lang) => items.reduce((a, i) => a + i.price[lang === "tr" ? "try" : "usd"] * i.qty, 0),
    };
  }, [items, open]);

  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);
